export const QUIZZES_FEATURE_KEY = 'quizzes';
